
import React from 'react';
import { Button, ButtonProps } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

interface FormActionsProps {
  onCancel: () => void;
  isSubmitting?: boolean;
  cancelLabel?: string;
  submitLabel?: string;
  cancelVariant?: ButtonProps['variant'];
  submitVariant?: ButtonProps['variant'];
  cancelIcon?: React.ReactNode;
  submitIcon?: React.ReactNode;
  className?: string;
}

export const FormActions: React.FC<FormActionsProps> = ({
  onCancel,
  isSubmitting = false,
  cancelLabel = 'Cancel',
  submitLabel = 'Submit Feedback',
  cancelVariant = 'outline',
  submitVariant = 'default',
  cancelIcon,
  submitIcon,
  className = 'flex justify-end gap-2 pt-2',
}) => {
  return (
    <div className={className}>
      <Button 
        type="button" 
        variant={cancelVariant} 
        onClick={onCancel} 
        disabled={isSubmitting}
      >
        {cancelIcon}
        {cancelLabel}
      </Button>
      <Button 
        type="submit" 
        variant={submitVariant}
        disabled={isSubmitting}
      >
        {isSubmitting ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Submitting...
          </>
        ) : (
          <>
            {submitIcon}
            {submitLabel}
          </>
        )}
      </Button>
    </div>
  );
};
